module.exports = import("/usagelogs/remoteEntry.js");